import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__title"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "bi-tmpl-detail__right__cmpt__title",
  style: {"margin-top":"0"}
}, " 请选择图表样式（请至少选择6种图形） ", -1)
const _hoisted_4 = {
  key: 0,
  style: {"margin-top":"0"},
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_5 = { style: {"height":"240px","overflow":"hidden"} }


import PcModulePromotion from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-promotion';

import { BaseCard, BaseCheckbox } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useCheck } from './hooks/use-check';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-20',
  props: ['disabled'],
  setup(__props) {



const TYPE_MAPPING = [
  {
    com: 'pc-module-promotion-1',
    index: 1,
    value: '18'
  },
  {
    com: 'pc-module-promotion-2',
    index: 2,
    value: '2'
  },
  {
    com: 'pc-module-promotion-3',
    index: 3,
    value: '9'
  },
  {
    com: 'pc-module-promotion-4',
    index: 4,
    value: '10'
  },
  {
    com: 'pc-module-promotion-5',
    index: 5,
    value: '14'
  },
  {
    com: 'pc-module-promotion-6',
    index: 6,
    value: '16'
  },
  {
    com: 'pc-module-promotion-7',
    index: 7,
    value: '15'
  },
  {
    com: 'pc-module-promotion-8',
    index: 8,
    value: '20'
  },
  {
    com: 'pc-module-promotion-9',
    index: 9,
    value: '17'
  },
  {
    com: 'pc-module-promotion-10',
    index: 10,
    value: '21'
  },
  {
    com: 'pc-module-promotion-11',
    index: 11,
    value: '22'
  }
];

const { checkData, curItem, onChangeFn, group } = useCheck({
  childKey: '',
  max: 6
});

const cmpName = name => {
  return PcModulePromotion.filter(comp => comp.__name === name)[0];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(curItem).tips)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(curItem).title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_3,
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 1000,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(group)(TYPE_MAPPING, 3), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"width":"100%"},
            key: index
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (child) => {
              return (_openBlock(), _createBlock(_unref(BaseCard), {
                key: child.value,
                style: {"width":"420px","height":"300px","margin-bottom":"18px","text-align":"center"},
                onClick: 
            () => {
              if (__props.disabled) return;
              _unref(onChangeFn)(child.value, !_unref(checkData)?.includes(child.value));
            }
          
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(child.com))))
                  ]),
                  _createVNode(_unref(BaseCheckbox), {
                    "model-value": _unref(checkData)?.includes(child.value),
                    value: child.value,
                    disabled: __props.disabled
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(), 1)
                    ]),
                    _: 2
                  }, 1032, ["model-value", "value", "disabled"])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})